enum notificationTypes {
  Open_Notification = "Open_Notification",
  Close_Notification = "Close_Notification",
}

export default notificationTypes;
